import { render } from "./cooperation.vue?vue&type=template&id=7e1e103b&scoped=true"
import script from "./cooperation.vue?vue&type=script&lang=js"
export * from "./cooperation.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7e1e103b"

export default script